<template>
  <b-container fluid class="headerPushDown voucherContainer">    
    <b-container class="voucherContainer">
      <h2 class="text-center margin-bottom-2 ueberschriften">Gutscheine</h2>
      <section class="text-center no-padding-bottom">
        <div class="container">
          <div class="col-md-12 text-center no-padding-bottom">
            <span class="title-large text-uppercase letter-spacing-3 font-weight-700 black-text display-block">For you my dear</span>
            <div class="wide-separator-line bg-mid-gray margin-two no-margin-strich"></div>
            <span class="text-large text-uppercase letter-spacing-3 display-block font-weight-600">DAS GLÜCK DES LEBENS IST DAS GLÜCK DES GEBENS</span>
          </div>
        </div>
      </section>
      <br/><br/>
        <section class="text-center">
          <div class="container">
            <div class="row pl-1 pr-1 text-center">
              <div class="col-lg-6 col-6 xs-no-padding-left-right">
                <span class="text-large text-uppercase letter-spacing-3 display-block font-weight-600 margin-two">PDF-SOFORTVERSAND</span>
                <h5 class="margin-four-bottom">Personalisierbar: Text & Motivauswahl</h5>
              </div>
              <div class="col-lg-6 col-6 xs-no-padding-left-right">
                <span class="text-large text-uppercase letter-spacing-3 display-block font-weight-600 margin-two">GESCHENKKARTE</span>
                <h5 class="margin-four-bottom">orginelle Verpackung</h5>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row pl-1 pr-1 text-center">
              <div class="col-lg-6 col-6 xs-no-padding-left-right">
                <img src="/images/wertgutschein1.jpg" class="skylineauswahl" alt="" width="80%">
                <a href="https://www.kahlenberg.wien/app/category/6b394fbf-2572-4053-8a43-8c027f6bf6ab" target="_parent" class="btn-small-black-border-light btn btn-medium button xs-margin-bottom-five margin-four">PDF & Post</a>
              </div>
              <div class="col-lg-6 col-6 xs-no-padding-left-right">
                <img src="/images/gutscheinkarten.jpg" class="skylineauswahl" alt="" width="80%">
                <a href="https://www.kahlenberg.wien/app/category/0b3fc221-b6c2-447b-99b3-09f2a39c63ab" target="_parent" class="btn-small-black-border-light btn btn-medium button xs-margin-bottom-five margin-four">Postversand</a>
              </div>
            </div>
          </div>
        </section>
      <br/><br/>
      <shop-categories-panel :searchTag="'SidemenuVoucher'"/>   
    </b-container>
  </b-container> 
</template>

<script>
import ShopCategoriesPanel from '@/components/ShopCategoriesPanel'

export default {
  name: 'shopVoucherIndex',
  components: {  
    ShopCategoriesPanel,
  },
  data() {
    return {      
      panelData: [],
      selectedGroup: undefined,
      products: undefined,

    };
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() { 
      return this.$store.getters.getLanguageStrings;
    },
  },
  methods: {
    async loadGroupsFromServer(searchTags) {

      let config = this.$store.getters.getRestHeaderConfig;
      config.params = {
          searchTags: searchTags,
          imageSize: "medium" /* small, medium, big */,
          localeId: this.getSelectedLanguage.ident /* Language: de, en */
      };

      await this.$http
        .get(
          this.$store.getters.getRestServerBaseUrl + "/productGroups",
          config
        )
        .then(response => {
          //console.log("productGroups: ", searchTags, response.data);
          // Check Data ?
          if(response.data != undefined && response.data.length > 0 ){
            
            this.panelData = response.data;

            this.panelData.forEach((g) => {
             // console.log('updating Group: ', g.id);
               //this loads Details and Products and puts it into the given group
               g.details =  this.loadProductDetailsFromServer(g); 
          //    /* g.products = */ this.loadProductsFromServer(g); 
            });

            // if we run the first time, select first group
            if(this.selectedGroup == undefined && this.panelData[0] != undefined){
              //console.log('Select first group:', this.panelData[0]);
              
              this.selectedGroup = this.panelData[0];

              this.products = this.loadProductsFromServer(this.selectedGroup);            
            }



          }else{
            //console.log('productGroups ERROR: No Data received');            
          }

        })
        .catch(err => {
          console.log(' GET productGroups ERROR:',err);
          this.panelData = [];
        });
    },
    async loadProductDetailsFromServer(group) {
      let config =this.$store.getters.getRestHeaderConfig;
      config.params= {
        groupId: group.id,
        imageSize: "big" /* small, medium, big */,
        localeId: this.getSelectedLanguage.ident /* Language: de, en */
      };

      // Group Details
      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/productGroupDetail", config)
        .then(response => {
          //console.log("Group OK: " + response.status);
         // group.details =  response.data;
          return  response.data;
        })
        .catch(err => {
          console.log('GroupDetail ERROR: ', err);
          
        });

    },
    async loadProductsFromServer(group) {
      let config =this.$store.getters.getRestHeaderConfig;
      config.params= {
        groupId: group.id,
        imageSize: "big" /* small, medium, big */,
        localeId: this.getSelectedLanguage.ident /* Language: de, en */
      };
      //console.log('get Products: ', config);
      

      // GroupProducts
      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/products", config)
        .then(response2 => {
          //console.log("Products OK: ", response2.status, group.id , response2.data );
          this.products = response2.data;

          return response2.data;
        })
        .catch(err => {
          console.log("/products ERORR", err);          
        });
    },
  }, 
  beforeMount() {    
    
  },
  mounted(){
   window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    }); 
  }
}
</script>
